var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9300_197509",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9647 3.99386C12.7158 3.77443 12.4326 3.52621 12.0952 3.21421C11.9423 3.09078 11.775 2.94952 11.5974 2.80003C10.5963 1.95592 9.2249 0.799805 7.97488 0.799805C6.73926 0.799805 5.45629 1.89146 4.42569 2.76849C4.23507 2.93032 4.05679 3.08255 3.87508 3.22998C3.55554 3.52621 3.27235 3.77512 3.02276 3.99523C1.386 5.43592 1.07812 5.81375 1.07812 9.17444C1.07812 15.1998 2.82048 15.1998 7.99408 15.1998C13.167 15.1998 14.91 15.1998 14.91 9.17444C14.91 5.81306 14.6021 5.43523 12.9647 3.99386Z",
    fill: "url(#paint0_linear_9300_197509)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9300_197509)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9300_197509)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#paint1_linear_9300_197509)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9300_197509",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 10,
    width: 6,
    height: 2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99865 11.3499H9.98599C10.2699 11.3499 10.5003 11.1195 10.5003 10.8356C10.5003 10.5517 10.2699 10.3213 9.98599 10.3213H5.99865C5.71477 10.3213 5.48438 10.5517 5.48438 10.8356C5.48438 11.1195 5.71477 11.3499 5.99865 11.3499Z",
    fill: "url(#paint2_linear_9300_197509)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9300_197509)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9300_197509)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.800781,
    y: -0.799805,
    width: 16,
    height: 16,
    fill: "url(#paint3_linear_9300_197509)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9300_197509",
    x1: 1.07812,
    y1: 0.799805,
    x2: 1.07812,
    y2: 15.1998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9300_197509",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9300_197509",
    x1: 5.48438,
    y1: 10.3213,
    x2: 5.48438,
    y2: 11.3499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9300_197509",
    x1: -0.800781,
    y1: -0.799805,
    x2: -0.800781,
    y2: 15.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9300_197509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9300_197509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(-0.800781 -0.799805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.4d77d0ae4cae164029175d33a16a54f8.svg";
export { ForwardRef as ReactComponent };